import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { staffApi, setStaffCsrf } from '../lib/staffApi';
import pages from '../content/pages.json';

const StaffContext = createContext(null);
export const StaffAuthProvider = ({children}) => {
  const [user, setUser] = useState(null);
  const sessionVersion = useRef(0);
  useEffect(() => {
    document.body.className = pages['/'].bodyClass;
    let active = true;
    const version = sessionVersion.current;
    staffApi('/auth/me').then(data => { if (active && version === sessionVersion.current) {setStaffCsrf(data.csrfToken); setUser(data.user);} })
      .catch(() => { if (active && version === sessionVersion.current) setUser(false); });
    return () => { active = false; };
  }, []);
  const signIn = async (email, password) => {
    sessionVersion.current++;
    const data = await staffApi('/auth/login', {method: 'POST', body: {email, password}, retry: false});
    setStaffCsrf(data.csrfToken); setUser(data.user);
  };
  const signOut = async () => {
    sessionVersion.current++;
    try { await staffApi('/auth/logout', {method: 'POST'}); }
    catch (error) { if (error.status !== 401) throw error; }
    setStaffCsrf(''); setUser(false);
  };
  return <StaffContext.Provider value={{user, signIn, signOut}}>{children}</StaffContext.Provider>;
};
export const useStaffAuth = () => useContext(StaffContext);
export const StaffOnly = ({children}) => {
  const {user} = useStaffAuth(); const location = useLocation();
  if (user === null) return <div className="staff-loading" data-testid="staff-session-loading">Checking staff session…</div>;
  if (!user) return <Navigate to="/staff/login" replace state={{from: location.pathname}} />;
  return children;
};